export default (amount, currency = 'GBP') => {
  let currencySymbol = '£';

  if (currency === 'EUR') currencySymbol = '€';

  return `${currencySymbol}${(amount / 100).toFixed(2)}`;
};
